var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-tab-container"},[_vm._l((_vm.computedData),function(ref,dataIndex){
var data = ref[0];
var dataValue = ref[1];
return _c('InfoCard',{key:("data-" + dataIndex),attrs:{"title":data}},_vm._l((_vm.getEntries(dataValue)),function(ref,keyIndex){
var key = ref[0];
var keyValue = ref[1];
return _c('InfoBox',{key:("order-" + keyIndex + "-" + key),attrs:{"card":data,"title":keyValue.label || key,"isDate":_vm.isDateString(keyValue.value),"data":keyValue}})}),1)}),_c('InfoCard',{attrs:{"title":"Observations"}},[_c('div',{staticClass:"observation",domProps:{"innerHTML":_vm._s(_vm.data.Observations)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }